import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { ShipmentWaybillSapDeliveriesFacade } from './shipment-waybill-sap-deliveries.facade';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillSapDeliveriesGuard {
  constructor(private shipmentWaybillSapDeliveriesFacade: ShipmentWaybillSapDeliveriesFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.shipmentWaybillSapDeliveriesFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentWaybillSapDeliveriesFacade);
  }
}
